import { useEffect } from "react";
import { studyOnboardingService } from "../APIServices/studyOnboarding";
import dataLoader from "../img/manWalk.gif"
const DirectStudyLogin = () => {
  useEffect(() => {
    const loginFlow = async () => {
      const storedStudyId = JSON.parse(localStorage.getItem("studyId") || "null");
      const storedCategory = JSON.parse(localStorage.getItem("category") || "null");
      const storedAppAccess = JSON.parse(localStorage.getItem("appAccess") || "null");
      const storedAssignPermission = JSON.parse(localStorage.getItem("assignStudyPermission") || "null");

      if (!storedStudyId || !storedCategory || !storedAssignPermission) {
        console.log("Missing required data in localStorage.");
        return;
      }

      const projectId = await studyOnboardingService.getProjectIdByStudyId(storedStudyId);
      if (!projectId?.data) {
        console.log("Project ID not found.");
        return;
      }

      const commonSetup = () => {
        localStorage.removeItem("studyTabs");
        localStorage.setItem("clientLabel", JSON.stringify(projectId.data.sponsorName));
        localStorage.setItem("projectLabel", JSON.stringify(projectId.data.projectLabel));
        localStorage.setItem("previousRole", JSON.stringify("user"));
        localStorage.setItem("loginType", JSON.stringify("direct"));
        localStorage.setItem("studyStatus", JSON.stringify("active"));
        localStorage.setItem("studyStatusData", JSON.stringify("active"));
        localStorage.removeItem("studyId");
        localStorage.removeItem("studyName");
        localStorage.removeItem("projectName");
      };

      const setPermissions = (type) => {
        const modeMap = {
          DBP: "DBP Mode",
          DV: "DV Mode",
          LIVE: "Live Mode",
          QC: "QC Mode",
          SDVLIVE: "SDV Live Mode",
          SDVQC: "SDV QC Mode",
        };

        const permissionMap = {
          DBP: storedAppAccess?.DBPPermission?.[0],
          DV: storedAppAccess?.DVPermission?.[0],
          LIVE: storedAppAccess?.LivePermission?.[0],
          QC: storedAppAccess?.QCPermission?.[0],
          SDVLIVE: storedAppAccess?.SDVLivePermission?.[0],
          SDVQC: storedAppAccess?.SDVQCPermission?.[0],
        };

        return {
          mode: modeMap[type] || "No Mode",
          permission: permissionMap[type] || "",
        };
      };

      if (storedCategory === "edc") {
        commonSetup();
        const { mode, permission } = setPermissions(storedAssignPermission);
        localStorage.setItem("role", JSON.stringify("edc"));
        localStorage.setItem("StudyMode", JSON.stringify(mode));
        localStorage.setItem("studyPermissionData", JSON.stringify(permission));
        localStorage.setItem("studyPermissionId", JSON.stringify(storedAppAccess?.permissionId || ""));
        localStorage.setItem("studyManagement", JSON.stringify(storedAppAccess?.permissionRole || ""));
        window.location.href = `/edc/${storedStudyId}`;
      } else if (storedCategory === "iwrs") {
        commonSetup();
        const { mode, permission } = setPermissions(storedAssignPermission);
        localStorage.setItem("role", JSON.stringify("iwrs"));
        localStorage.setItem("StudyMode", JSON.stringify(mode));
        localStorage.setItem("iwrsPermissionData", JSON.stringify(permission));
        localStorage.setItem("studyPermissionId", JSON.stringify(storedAppAccess?.permissionId || ""));
        localStorage.setItem("studyManagement", JSON.stringify(storedAppAccess?.permissionRole || ""));
        window.location.href = `/iwrs/${storedStudyId}`;
      }
    };

    loginFlow(); 
  }, []);

  return <>
    <div className="hstack justify-content-center" style={{height: "100vh"}}>
      <img src={dataLoader} alt="Man Walk" style={{width: 350, height: 350}} />
    </div>
  </>;
};

export default DirectStudyLogin;